export default __webpack_public_path__ + "8fc4e7082411975c26157f1832d39301.jpg";